import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router';
import CollegePage from '@/views/collegePage/CollegePage.vue'
import CollegeSituation from '@/views/collegePage/CollegeSituation.vue'
import MajorPage from '@/views/majorPage/MajorPage.vue'
import MajorSituation from '@/views/majorPage/MajorSituation.vue'
import TransferPage from '@/views/transferPage/TransferPage.vue'
import DisciplinePage from '@/views/disciplinePage/DisciplinePage.vue'
import FirstPage from '@/views/firstPage/FirstPage.vue'
import ProfessionSearch from '@/views/professionSearch/ProfessionSearch.vue'
import ProfessionPage from '@/views/professionPage/ProfessionPage.vue'
import MajorSearch from '@/views/majorSearch/MajorSearch.vue'
import HomePage from '@/views/majorSearch/HomePage.vue'
import MasterPage from '@/views/undergraduateMasterConnect/MasterPage.vue'
import UnderGraduatePage from '@/views/undergraduateMasterConnect/UnderGraduatePage.vue'
import MobileCollegePage from '@/views/mobileTerminal/mobileCollegePage/MobileCollegePage.vue'
import MobileCollegeSituation from '@/views/mobileTerminal/mobileCollegePage/MobileCollegeSituation.vue'
import MobileMajorPage from '@/views/mobileTerminal/mobileMajorPage/MobileMajorPage.vue'
import MobileMajorSituation from '@/views/mobileTerminal/mobileMajorPage/MobileMajorSituation.vue'
import MobileTransferPage from '@/views/mobileTerminal/mobileTransferPage/MobileTransferPage.vue'
import MobileFirstPage from '@/views/mobileTerminal/mobileFirstPage/MobileFirstPage.vue'
import MobileProfessionSearch from '@/views/mobileTerminal/mobileProfessionSearch/MobileProfessionSearch.vue'
import MobileProfessionPage from '@/views/mobileTerminal/mobileProfessionPage/MobileProfessionPage.vue'

import MobileMajorSearch from '@/views/mobileTerminal/mobileMajorSearch/MobileMajorSearch.vue'
import MobileDisciplinePage from '@/views/mobileTerminal/mobileDisciplinePage/MobileDisciplinePage.vue'
import MobileUnderGraduatePage from '@/views/mobileTerminal/mobileUnderGraduatePage/MobileUnderGraduatePage.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/CollegePage/:id',
    name: 'CollegePage',
    component: CollegePage,
    children: [
      {
        path: '/:id',
        name: 'CollegeSituation',
        component: CollegeSituation,
        meta:{
          title:'院校详情'
        }
      },
    ]
  },
  {
    path: '/MajorPage/:id',
    name: 'MajorPage',
    component: MajorPage,
    children: [
      {
        path: '/MajorSituation/:collegeCode?/:id',
        name: 'MajorSituation',
        component: MajorSituation,
        meta:{
          title:'专业详情'
        }
      },

    ]
  },
  {
    path: '/TransferPage/:collegeCode?/:id',
    name: 'TransferPage',
    component: TransferPage,
    meta:{
      title:'专业查询'
    },
  },
  {
    path: '/DisciplinePage/:category/:type',
    name: 'DisciplinePage',
    component: DisciplinePage,
    meta:{
      title:'学科门类'
    }
  },

  {
    path: '/',
    name: 'FirstPage',
    component: FirstPage,
    meta:{
      title:'院校查询'
    }
  },

  {
    path: '/MajorSearch',
    name: 'MajorSearch',
    component: MajorSearch,
    meta:{
      title:'专业搜索'
    }
  },

  {
    path: '/ProfessionSearch',
    name: 'ProfessionSearch',
    component: ProfessionSearch,
    meta:{
      title:'职业查询'
    }
  },

  {
    path: '/ProfessionPage/:occId',
    name: 'ProfessionPage',
    component: ProfessionPage,
    meta:{
      title:'职业详情'
    }
  },

  {
    path: '/HomePage',
    name: 'HomePage',
    component: HomePage,
    meta:{
      title:'首页'
    }
  },


  {
    path: '/MasterPage/:collegeCode/:majorCode',
    name: 'MasterPage',
    component: MasterPage,
    meta:{
      title:'硕士页面'
    }
  },
  {
    path: '/UnderGraduatePage/:masterCode',
    name: 'UnderGraduatePage',
    component: UnderGraduatePage,
    meta:{
      title:'本科页面'
    }
  },



  {
    path: '/MobileCollegePage/:id',
    name: 'MobileCollegePage',
    component: MobileCollegePage,
    children: [
      {
        path: '/MobileCollegeSituation/:id',
        name: 'MobileCollegeSituation',
        component: MobileCollegeSituation,
        meta:{
          title:'院校详情'
        }
      },
    ]
  },

  {
    path: '/MobileMajorPage/:id',
    name: 'MobileMajorPage',
    component: MobileMajorPage,
    children: [
      {
        path: '/MobileMajorSituation/:collegeCode?/:id',
        name: 'MobileMajorSituation',
        component: MobileMajorSituation,
        meta:{
          title:'专业详情'
        }
      },
    ]
  },

  {
    path: '/MobileTransferPage/:collegeCode?/:id',
    name: 'MobileTransferPage',
    component: MobileTransferPage,
    meta:{
      title:'专业查询'
    },
  },
  {
    path: '/MobileFirstPage',
    name: 'MobileFirstPage',
    component: MobileFirstPage,
    meta:{
      title:'院校查询'
    }
  },
  {
    path: '/MobileProfessionSearch',
    name: 'MobileProfessionSearch',
    component: MobileProfessionSearch,
    meta:{
      title:'职业查询'
    }
  },

  {
    path: '/MobileProfessionPage/:occId',
    name: 'MobileProfessionPage',
    component: MobileProfessionPage,
    meta:{
      title:'职业详情'
    }
  },

  {
    path: '/MobileMajorSearch',
    name: 'MobileMajorSearch',
    component: MobileMajorSearch,
    meta:{
      title:'专业搜索'
    }
  },

  {
    path: '/MobileDisciplinePage/:category/:type',
    name: 'MobileDisciplinePage',
    component: MobileDisciplinePage,
    meta:{
      title:'学科门类'
    }
  },

  {
    path: '/MobileUnderGraduatePage/:masterCode',
    name: 'MobileUnderGraduatePage',
    component: MobileUnderGraduatePage,
    meta:{
      title:'本科页面'
    }
  },



];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to,from,next)=>{
  if (to.meta.title){
    document.title = to.meta.title as string;
    next();
  }
});

export default router;
